import { Box, Chip, Typography } from '@mui/material';

import { ApprovalMode } from 'openapi';

import { useTranslations } from 'context/TranslationContext';

import {
  getApprovalModeChipStyle,
  getApprovalModeLabel
} from 'utils/helpers/approvalsHelpers';

import { baseHeader } from 'styles/components/Common';
import {
  finalGateApproversStyle,
  finalGateCardStyle,
  finalGateHeaderStyle,
  finalGateNameStyle,
  finalGateNumberStyle,
  matchedRulesSectionStyle
} from 'styles/pages/ApprovalRuleSimulatorStyles';

import { FinalGate } from '../../../../utils/interfaces/ApprovalSimulator';

export interface FinalGatesSectionProps {
  gates: FinalGate[];
}

export const FinalGatesSection = ({ gates }: FinalGatesSectionProps) => {
  const { translate } = useTranslations();

  if (gates.length === 0) {
    return null;
  }

  return (
    <Box sx={matchedRulesSectionStyle}>
      <Typography sx={baseHeader}>
        {translate('approvalSimulator.results.finalGates')}
      </Typography>

      {gates.map((gate) => (
        <Box key={`gate-${gate.gateNumber}`} sx={finalGateCardStyle}>
          <Box sx={finalGateHeaderStyle}>
            <Box sx={finalGateNumberStyle}>
              {translate('approvalSimulator.results.gate', {
                number: gate.gateNumber.toString()
              })}
            </Box>

            <Typography sx={finalGateNameStyle}>{gate.ruleName}</Typography>

            {gate.approvalMode && (
              <Chip
                size="small"
                label={getApprovalModeLabel(gate.approvalMode, translate)}
                sx={getApprovalModeChipStyle(gate.approvalMode.toString())}
              />
            )}
          </Box>

          {gate.approvers &&
            (gate.approvalMode === ApprovalMode.SEQUENTIAL ||
              gate.approvalMode === ApprovalMode.PARALLEL) && (
              <Box>
                <Typography sx={finalGateApproversStyle}>
                  {gate.approvalMode === ApprovalMode.PARALLEL
                    ? `${gate.minimumApprovalsRequired} ${translate('labels.of')} ${gate.approvers.length}: ${gate.approvers.map((a) => a.approver?.name).join(', ')}`
                    : `${translate('approvals.sequential')}: ${gate.approvers.map((a) => a.approver?.name).join(' → ')}`}
                </Typography>
              </Box>
            )}
        </Box>
      ))}
    </Box>
  );
};
